import { render, staticRenderFns } from "./Kodeks.vue?vue&type=template&id=0ba2a0fa&"
import script from "./Kodeks.vue?vue&type=script&lang=js&"
export * from "./Kodeks.vue?vue&type=script&lang=js&"
import style0 from "./Kodeks.vue?vue&type=style&index=0&id=0ba2a0fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports